import { render, staticRenderFns } from "./AtmSidebar.vue?vue&type=template&id=054e2677&"
import script from "./AtmSidebar.vue?vue&type=script&lang=js&"
export * from "./AtmSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054e2677')) {
      api.createRecord('054e2677', component.options)
    } else {
      api.reload('054e2677', component.options)
    }
    module.hot.accept("./AtmSidebar.vue?vue&type=template&id=054e2677&", function () {
      api.rerender('054e2677', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/components/sidebar/AtmSidebar.vue"
export default component.exports